import React, { useEffect, useState } from 'react'
import { Plus } from '@phosphor-icons/react'
import TicketComp from './TicketComp'
import AdmissionTicket from '../Modals/AdmissionTickets/AdmissionTicket'
import { classesEventStore } from 'state/classes/classesStore'
import { AdditionalTicketResp, TicketsResp } from 'types/event/eventStep4'
import { infoMessage } from 'api/global'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

interface TicketRowProps {
  type: 'admission' | 'additional'
}

interface ClassesDataShape {
  _id: string
  admissionTickets: TicketsResp[]
  additionalOptions: AdditionalTicketResp[]
}

const TicketRow: React.FC<TicketRowProps> = ({ type }) => {
  const { _id, admissionTickets, additionalOptions } = classesEventStore(
    store => store.classesData,
  ) as ClassesDataShape

  const [admissionModalOpen, setAdmissionModalOpen] = useState<boolean>(false)

  const onDragEnd = (result: any) => {
    if (!result.destination) return

    const items = Array.from(
      type === 'admission' ? admissionTickets : additionalOptions,
    )
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)

    const updatedItems = items.map((ticket, index) => ({
      ...ticket,
      order: index + 1,
    }))

    // Update the state with the new order
    classesEventStore.setState(state => ({
      ...state,
      classesData: {
        ...(state as any).classesData,
        [type === 'admission' ? 'admissionTickets' : 'additionalOptions']:
          updatedItems,
      },
    }))
  }

  const handleAddClick = (rowType: 'admission' | 'additional') => {
    if (rowType === 'additional' && (!admissionTickets || admissionTickets.length === 0)) {
      return infoMessage('First create an admission ticket')
    }
    setAdmissionModalOpen(true)
  }



  return (
    <>
      <div className="mt-20px">
        <div className="flex align-center justify-between ">
          <div>
            <p className="text-16 w-600">
              {type === 'admission'
                ? 'Admission Ticket'
                : type === 'additional'
                  ? 'Additional Ticket'
                  : null}
            </p>
          </div>
          <div
            className="w-36px h-36px radius-rounded bg-blue flex align-center justify-center pointer"
            onClick={() => handleAddClick(type)}
          >
            <Plus size={12} color="#fff" />
          </div>
        </div>

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable
            droppableId={
              type === 'admission' ? 'admissionTickets' : 'additionalOptions'
            }
          >
            {provided => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {(type === 'admission' ? admissionTickets : additionalOptions)
                  ?.length > 0 &&
                  (type === 'admission'
                    ? admissionTickets
                    : additionalOptions
                  ).map((ticket: TicketsResp, index: number) => (
                    <Draggable
                      key={ticket._id}
                      draggableId={ticket._id}
                      index={index}
                    >
                      {provided => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <TicketComp
                            visible={ticket.status === 'active'}
                            details={ticket}
                            ticketType={type}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>

      </div>

      {admissionModalOpen && (
        <AdmissionTicket
          modalOpen={admissionModalOpen}
          modalClose={setAdmissionModalOpen}
          type={type}
        />
      )}
    </>
  )
}

export default TicketRow

